import React from 'react';
import styled from 'styled-components';
import PText from '../components/PText';
import AboutImg from '../assets/images/about-page-img.jpg';
import downloadresume from '../assets/downloadResume/resume.pdf';
import AboutInfoItems from '../components/AboutInfoItem';
import ContactBanner from '../components/ContactBanner';

const AboutPageStyles = styled.div`
  padding: 20rem 0 10rem 0;

  .button {
    font-size: 2.2rem;
    background-color: ${(props) =>
      props.outline ? 'transperant' : 'var(--gray-1)'};
    padding: 0.7em 2em;
    border: 2px solid var(--gray-1);
    border-radius: 8px;
    display: inline-block;
    color: ${(props) => (props.outline ? 'var(--gary-1)' : 'black')};
  }
  .top-section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
  }
  .left {
    flex: 3;
  }
  .right {
    flex: 2;
  }
  .about__subheading {
    font-size: 2.2rem;
    margin-bottom: 2rem;
    span {
      background-color: var(--deep-dark);
      padding: 0.5rem;
      border-radius: 8px;
    }
  }
  .about__heading {
    font-size: 3.6rem;
    margin-bottom: 3rem;
  }
  .about__info {
    margin-bottom: 4rem;
    .para {
      max-width: 100%;
    }
  }
  .right {
    img {
      border: 2px solid var(--gray-1);
    }
  }
  .about__info__items {
    margin-top: 15rem;
  }
  .about__info__item {
    margin-bottom: 10rem;
  }
  .about__info__heading {
    font-size: 3.6rem;
    text-transform: uppercase;
  }
  @media only screen and (max-width: 768px) {
    padding: 10rem 0;
    .top-section {
      flex-direction: column;
      gap: 5rem;
    }
    .about__subheading {
      font-size: 1.8rem;
    }
    .about__heading {
      font-size: 2.8rem;
    }
    .about__info__heading {
      font-size: 3rem;
    }
  }
`;

export default function About() {
  return (
    <>
      <AboutPageStyles>
        <div className="container">
          <div className="top-section">
            <div className="left">
              <p className="about__subheading">
                Hi, I am <span>Mustafa Yusuf Karanjawala</span>
              </p>
              <h2 className="about__heading">A Software Engineer</h2>
              <div className="about__info">
                <PText>
                  A frontend and backend software engineer with a year of
                  experience working as webmaster.Self Starter quick learner and
                  having expert in business development and website networking,
                  blogs reaching over the thousands of active users and serving
                  the company by innovative ideas.
                  <br /> <br />
                  I m the founder of start-up name Photo-G Technologies,Our aim
                  to create and develop the websites in such a way that every
                  person should have their persnal web, just like they have
                  their Instagram facebook ect profiles.We have succussfully
                  created 30+ websites and provided to our clients with holding
                  expectations in a very affortable price.
                  <br /> <br />
                </PText>
              </div>
              <a
                className="button"
                href={downloadresume}
                target="_blank"
                rel="nooperner noreferrer"
                download
              >
                Download Resume
              </a>
            </div>
            <div className="right">
              <img src={AboutImg} alt="me" />
            </div>
          </div>
          <div className="about__info__items">
            <div className="about__info__item">
              <h1 className="about__info__heading">Education</h1>

              <AboutInfoItems
                title="School"
                items={['MSB Education Institute.(ICSE)']}
              />
              <AboutInfoItems
                title="Higher School"
                items={['Sindhu Mahavidhalaya']}
              />
              <AboutInfoItems
                title="University"
                items={['Priyadarshini college of Engineering']}
              />
            </div>
            <div className="about__info__item">
              <h1 className="about__info__heading">My Skills</h1>

              <AboutInfoItems
                title="FrontEnd"
                items={[
                  'HTML',
                  'CSS',
                  'JavaScript',
                  'REACT',
                  'Typescript',
                  'Python',
                ]}
              />
              <AboutInfoItems
                title="BackEnd"
                items={['Node', 'Express', 'Mongoose', 'Stripe']}
              />
              <AboutInfoItems title="Database" items={['mongodb']} />
              <AboutInfoItems
                title="Cloud Hosting"
                items={['AWS', 'Google cloud platform']}
              />
              <AboutInfoItems
                title="DevOps"
                items={['DokerHub', 'Jenkins', 'Github']}
              />
              <AboutInfoItems
                title="Other"
                items={['Wordpress', 'Shopify', 'excelVBA']}
              />
            </div>
            <div className="about__info__item">
              <h1 className="about__info__heading">Experiences</h1>

              <AboutInfoItems
                title="2018-20"
                items={['Web Administrator Photo-G Technologies']}
              />
              <AboutInfoItems
                title="2020-21"
                items={['Front-end developer at Analytica360 ']}
              />
            </div>
          </div>
        </div>
        <ContactBanner />
      </AboutPageStyles>
    </>
  );
}
